/* eslint-disable no-console */
// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.10-6UolF5LZuIaZoDlY8wmT/mode=imports,min/optimized/keen-slider.js'

const { debounce } = window.BAO.Utils
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class CardCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.initialiseCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.initialiseCarousel = this.initialiseCarousel.bind(this)

    this.listeners.add(window, 'resize', debounce(this.initialiseCarousel, 100))
  }

  initialiseCarousel () {
    this.destroyCarousel()

    // Do not initialise if there are not enough slides.
    const slideCount = this.els?.slide?.elements?.length || 0

    if (window.innerWidth < 901 && slideCount < 2) return
    if (window.innerWidth >= 901 && slideCount < 4) return

    this.carousel = this.setupCarousel()
  }

  destroyCarousel () {
    this.els?.slides?.element?.removeAttribute('initialised')

    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: !isNaN(parseFloat(this.dataset.perViewMobile))
            ? parseFloat(this.dataset.perViewMobile)
            : 1.5,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.5,
              spacing: 15,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.5,
              spacing: 15,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: !isNaN(parseFloat(this.dataset.perView))
                ? parseFloat(this.dataset.perView)
                : 3.5,
              spacing: 15,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
